<template lang="pug">
  v-app
    template(v-if="!login")
      login
    template(v-else)
      dashboard-bar
    v-snackbar(v-model="alert" :color="alertProps.color" :timeout="3000" top right style="top: 55px") {{ alertProps.text }}

</template>

<script>
import Login from '@/views/Login'
import DashboardBar from '@/components/DashboardBar'

export default {
  name: 'App',
  components: { Login, DashboardBar },
  data: () => ({
    // alert: true,
    text: 'Save Success',
    color: 'success'
  }),
  computed: {
    login () {
      return this.$store.state.loggedIn
    },
    alert: {
      set (val) {
        if (val === false) {
          this.$store.commit('clearAlert')
        }
      },
      get () {
        return this.$store.state.alert
      }
    },
    alertProps () {
      return this.$store.state.alertProps
    }
  },
  created () {
    this.$vuetify.theme.dark = true
  }
}
</script>

<style lang="scss">
p.copyw {
  margin-bottom: 0 !important;
}
</style>